/**
 * @what intercept all http requests to add a slash (all our servers require this) and add failure functions to respond to http error codes
 * @why general logging and event trapping of network communication
 */
angular.module('utility-ng-configuration').provider('NetworkFaultConfiguration', function NetworkFaultConfigurationProvider($httpProvider) {

  var configuration;
  var requestFailures = [];
  var responseFailures = {};

  var onRequestFailure = this.onRequestFailure = function onRequestFailure(fn) {
    requestFailures.push(fn);
    return this;
  };

  var onResponseFailure = this.onResponseFailure = function onResponseFailure(status, fn) {
    responseFailures[status] = responseFailures[status] || [];
    responseFailures[status].push(fn);
    return this;
  };

  var configure = this.configure = function configure_ConsistentRouteConfiguration(userConfig) {

    if (!!userConfig) {
      configuration = _.defaults({}, userConfig);
    }

    return configuration;
  };

  this.activate = function activate_NetworkFaultConfiguration(userConfig) {

    this.configure(userConfig);

    $httpProvider.interceptors.push(function ($q) {
      return {

        requestError: function (rejection) {

          if (!rejection) {
            return $q.defer();
          }

          _.each(requestFailures, function (fn) {
            fn(this);
          }, rejection);

          return $q.reject(rejection);
        },
        responseError: function responseHTTPInterceptorFailure(rejection) {

          if (!rejection) {
            return $q.defer();
          }

          _.each(responseFailures[rejection.status], function (fn) {
            fn(this);
          }, rejection);

          return $q.reject(rejection);
        }

      };
    });

    return configuration;
  };

  this.$get = function () {
    return {
      onRequestFailure: onRequestFailure,
      onResponseFailure: onResponseFailure,
      configure: configure
    };
  };

});


// WEBPACK FOOTER //
// network_failure_configuration.js